// src/lib/categories.ts — the expense categories, matching the prototype.
//
// trip_expenses.category is free text with a default of 'other', so this list
// is a UI convenience rather than a constraint. An expense written by some
// future version of the app with a category not in this list still renders —
// it falls back to the "Other" entry rather than disappearing.

export type CategoryKey = 'food' | 'transport' | 'stay' | 'activities' | 'shopping' | 'other';

export interface Category {
  key: CategoryKey;
  label: string;
}

export const CATEGORIES: Category[] = [
  { key: 'food', label: 'Food' },
  { key: 'transport', label: 'Transport' },
  { key: 'stay', label: 'Stay' },
  { key: 'activities', label: 'Activities' },
  { key: 'shopping', label: 'Shopping' },
  { key: 'other', label: 'Other' },
];

const OTHER = CATEGORIES[CATEGORIES.length - 1];

export function categoryOf(key: string | null | undefined): Category {
  return CATEGORIES.find((c) => c.key === key) ?? OTHER;
}
